import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import { Checkbox } from '../../../components/ui/Checkbox';
import Select from '../../../components/ui/Select';

const PrivacySection = ({ privacySettings, onUpdate }) => {
  const [settings, setSettings] = useState({
    profileVisibility: privacySettings?.profileVisibility || 'public',
    allowFollowers: privacySettings?.allowFollowers !== false,
    showFollowerCount: privacySettings?.showFollowerCount !== false,
    allowComments: privacySettings?.allowComments !== false,
    allowDownloads: privacySettings?.allowDownloads !== false,
    showListeningHistory: privacySettings?.showListeningHistory !== false,
    dataSharing: privacySettings?.dataSharing !== false,
    analyticsTracking: privacySettings?.analyticsTracking !== false
  });

  const visibilityOptions = [
    { value: 'public', label: 'Публичный', description: 'Виден всем пользователям' },
    { value: 'followers', label: 'Только подписчики', description: 'Виден только вашим подписчикам' },
    { value: 'private', label: 'Приватный', description: 'Виден только вам' }
  ];

  const handleCheckboxChange = (name, checked) => {
    setSettings(prev => ({
      ...prev,
      [name]: checked
    }));
  };

  const handleVisibilityChange = (value) => {
    setSettings(prev => ({
      ...prev,
      profileVisibility: value
    }));
  };

  const handleSave = () => {
    onUpdate(settings);
  };

  return (
    <div className="privacy-section bg-card rounded-lg p-6 shadow-soft">
      <div className="section-header flex items-center gap-3 mb-6">
        <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center">
          <Icon name="Shield" size={20} color="var(--color-primary)" />
        </div>
        <div>
          <h2 className="text-xl font-heading font-semibold text-foreground">
            Приватность
          </h2>
          <p className="text-sm text-muted-foreground">
            Управление видимостью и доступом к контенту
          </p>
        </div>
      </div>
      <div className="privacy-content space-y-6">
        <Select
          label="Видимость профиля"
          description="Кто может видеть ваш профиль"
          options={visibilityOptions}
          value={settings?.profileVisibility}
          onChange={handleVisibilityChange}
        />

        <div className="privacy-options space-y-4">
          <div className="option-group">
            <h3 className="text-sm font-medium text-foreground mb-3">
              Настройки подписчиков
            </h3>
            <div className="space-y-3">
              <Checkbox
                label="Разрешить подписки"
                description="Другие пользователи могут подписаться на ваш канал"
                checked={settings?.allowFollowers}
                onChange={(e) => handleCheckboxChange('allowFollowers', e?.target?.checked)}
              />
              <Checkbox
                label="Показывать количество подписчиков"
                description="Отображать число ваших подписчиков публично"
                checked={settings?.showFollowerCount}
                onChange={(e) => handleCheckboxChange('showFollowerCount', e?.target?.checked)}
              />
            </div>
          </div>

          <div className="option-group pt-4 border-t border-border">
            <h3 className="text-sm font-medium text-foreground mb-3">
              Контент и взаимодействие
            </h3>
            <div className="space-y-3">
              <Checkbox
                label="Разрешить комментарии"
                description="Пользователи могут оставлять комментарии к вашим эфирам"
                checked={settings?.allowComments}
                onChange={(e) => handleCheckboxChange('allowComments', e?.target?.checked)}
              />
              <Checkbox
                label="Разрешить скачивание"
                description="Слушатели могут скачивать ваши записи"
                checked={settings?.allowDownloads}
                onChange={(e) => handleCheckboxChange('allowDownloads', e?.target?.checked)}
              />
              <Checkbox
                label="Показывать историю прослушивания"
                description="Другие могут видеть, что вы слушали"
                checked={settings?.showListeningHistory}
                onChange={(e) => handleCheckboxChange('showListeningHistory', e?.target?.checked)}
              />
            </div>
          </div>

          <div className="option-group pt-4 border-t border-border">
            <h3 className="text-sm font-medium text-foreground mb-3">
              Данные и аналитика
            </h3>
            <div className="space-y-3">
              <Checkbox
                label="Разрешить обмен данными"
                description="Делиться анонимными данными для улучшения сервиса"
                checked={settings?.dataSharing}
                onChange={(e) => handleCheckboxChange('dataSharing', e?.target?.checked)}
              />
              <Checkbox
                label="Отслеживание аналитики"
                description="Собирать статистику использования для персонализации"
                checked={settings?.analyticsTracking}
                onChange={(e) => handleCheckboxChange('analyticsTracking', e?.target?.checked)}
              />
            </div>
          </div>
        </div>

        <div className="privacy-warning p-4 bg-warning/10 rounded-lg border border-warning/20">
          <div className="flex items-start gap-3">
            <Icon name="AlertTriangle" size={20} color="var(--color-warning)" />
            <div>
              <h4 className="text-sm font-medium text-foreground mb-1">
                Важная информация
              </h4>
              <p className="text-xs text-muted-foreground">
                Изменение настроек приватности может повлиять на видимость вашего контента и взаимодействие с аудиторией. Приватные профили не отображаются в поиске.
              </p>
            </div>
          </div>
        </div>

        <div className="form-actions flex items-center gap-3 pt-6 border-t border-border">
          <Button
            variant="default"
            onClick={handleSave}
            iconName="Check"
            iconPosition="left"
          >
            Сохранить настройки
          </Button>
        </div>
      </div>
    </div>
  );
};

export default PrivacySection;